import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';

import {
	PrismButtonComponent,
	PrismDialogRef,
	PRISM_DIALOG_DATA,
	PrismDialogComponent
} from '@shure/prism-angular-components';
import { provideInlineScope } from '@shure/shared/angular/utils/i18n';

import { DevicePasswordConfigurationComponent } from '../multi-device-password-setup';

export interface SingleDevicePasswordSetupDialogData {
	title: string;
}

@Component({
	selector: 'sh-single-device-password-setup-dialog',
	imports: [
		CommonModule,
		TranslocoModule,
		ReactiveFormsModule,
		FlexLayoutModule,
		PrismDialogComponent,
		PrismButtonComponent,
		DevicePasswordConfigurationComponent
	],
	providers: [provideInlineScope('scDeviceAuth', (lang) => import(`../../../../i18n/${lang}`))],
	templateUrl: './single-device-password-setup-dialog.component.html',
	styleUrl: './single-device-password-setup-dialog.component.scss'
})
export class SingleDevicePasswordSetupDialogComponent {
	public newPassword = '';

	constructor(
		public dialogRef: PrismDialogRef<SingleDevicePasswordSetupDialogComponent>,
		@Inject(PRISM_DIALOG_DATA) protected readonly data: SingleDevicePasswordSetupDialogData
	) {}

	public onSubmit(): void {
		if (this.newPassword) {
			this.dialogRef.close(this.newPassword);
		}
	}
	public onCancel(): void {
		this.dialogRef.close('');
	}

	public passwordChanged(password: string | undefined): void {
		this.newPassword = password ?? '';
	}
}
